import { Dispatch, useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { RootState } from 'src/store/reducers';

import InfoIcon from '@images/svg-icons/infoIcon.svg';
import ArrowDown16 from '@images/svg-icons/arrowDown16.svg';
import CheckPrescription from '@images/svg-icons/check-prescription.svg';
import BoxImage from './BoxImage';
import Modal from '@components/styled-UI/Modal';
import Error from '@images/svg-icons/functionalError.svg'

import {
    IGlobalOrderDetails,
    IOnlineOrderItems,
    OnlineOrderDetailsSkuDetails,
    OnlineOrderItemType,
    OrderDetailsContactLenses,
} from '@interfaces/myPurchasesInterfaces';

import * as actions from '@redux-actions/';

import { getOrderItemCarrierUrl, getPrescriptionInfo } from '@services/myPurchasesServices';

import { handleContactLensesReorder, mapContactLensesAttributes } from '@utils/pages-utils/MyPurchasesUtils';

import { getProductDetails, getLabelFallback, getMockedFile, isMobile, isCLAttributePresent } from '@utils/utils';
import URLS from '@utils/urlList';

import { v4 as uuidv4 } from 'uuid';

import axios, { AxiosRequestConfig } from 'axios';

import { MANUAL_PRESCRIPTION_DEFAULT_DOCTOR } from '@utils/const';

import PrescriptionModal from './PrescriptionModal';

interface Props {
    orderItem: IOnlineOrderItems;
    orderId: string;
    orderAddressEmail: string;
    billingAddressId: number;
    order?: IGlobalOrderDetails;
}

const mapOrderItemsAnalytics = (orderItems: IGlobalOrderDetails) => {
    let objects = {};
    if (orderItems.hasContactLenses && orderItems.orderStatus === "D") {
        orderItems.orderItems.forEach(item => {
            if (Array.isArray(item.partNumber)) {
                let price = null;
                let priceFull = null;

                if (Array.isArray(item.orderItemType) && Array.isArray(item.quantity)) {
                    //It Means that we have Left and Right contact so to calculate the unit price we need to sum L and R quantity
                    let quantity = Number(item.quantity[0]) + Number(item.quantity[1])

                    price = Number(item.newPrice.replace("$ ", "").trim()) / quantity;
                    priceFull = Number(item.oldPrice.replace("$ ", "").trim()) / quantity;
                }

                item.partNumber.forEach((id, index) => {
                    objects[id] = {
                        "Status": item.orderItemInventoryStatus,
                        "Category": "CONTACT LENSES",
                        "LensType": "PLANO",
                        "Price": !!price ? price.toString() : item.newPrice.replace("$ ", ""),
                        "PriceFull": !!priceFull ? priceFull.toString() : item.oldPrice.replace("$ ", ""),
                        "Units": Number(item.quantity[index]).toString(),
                        "ModelName": item.frame,
                        "Brand": item.brand,
                        "ReorderSource": "Ecom",
                        "Image": item.imgUrl,
                        "Url": window.location.origin + item.productPageUrl
                    }
                })
            } else {
                let price = Number(item.newPrice.replace("$ ", "")) / Number(item.quantity);
                let priceFull = Number(item.oldPrice.replace("$ ", "")) / Number(item.quantity);

                objects[item.partNumber] = {
                    "Status": item.orderItemInventoryStatus,
                    "Category": "CONTACT LENSES",
                    "LensType": "PLANO",
                    "Price": price.toString(),
                    "PriceFull": priceFull.toString(),
                    "Units": Number(item.quantity).toString(),
                    "ModelName": item.frame,
                    "Brand": item.brand,
                    "ReorderSource": "Ecom",
                    "Image": item.imgUrl,
                    "Url": window.location.origin + item.productPageUrl
                }
            }
        })

        return objects
    }
}

const renderShippedHeaderTile = (
    orderItemCarrierUrl: string,
    goToTrackingPage: (orderItemCarrierUrl: string) => Window,
    isDelivered: boolean,
    orderId: number,
    ocrAddressId: number,
    storeId: number,
    catalogId: number,
    langId: number,
    order: IGlobalOrderDetails,
    orderItemStatus: string,
    orderItemEdd: string,
    orderItemType: string,
    isCTEnabledTO: boolean,
): JSX.Element => {
    return (
        !!isCTEnabledTO && <div className="header">
            <div className="left">
                <div className="label">
                    {getLabelFallback(
                        'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_STATUS_LABEL'
                    )}
                </div>
                <div className="value">
                    {getLabelFallback(
                        isDelivered
                            ? 'MYPURCHASES_ONLINE_ORDERS_ORDER_STATUS_SHIPPED_LABEL'
                            : orderItemStatus === 'X' ? 'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_STATUS_CANCELLED_LABEL'
                                : orderItemStatus === 'Z' ? 'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_STATUS_RETURNED_LABEL_DESCRIPTION'
                                    : order.isExchangeOrder ? 'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_STATUS_EXCHANGED_LABEL'
                                        : orderItemStatus === 'S' ? 'MYPURCHASES_ONLINE_ORDERS_ORDER_STATUS_SHIPPED_LABEL'
                                            : 'MYPURCHASES_ONLINE_ORDERS_ORDER_STATUS_PRESCRIPTION_LABEL_DESCRIPTION'
                    )}
                </div>
                {!isDelivered && orderItemEdd && (
                    <>
                        <div className='edd-separator'>|</div>
                        <div className="edd-label">
                            {getLabelFallback(
                                'MYPURCHASES_ONLINE_ORDERS_ORDER_EDD_LABEL'
                            )}
                        </div>
                        <div className="label edd-value">
                            {orderItemEdd.replaceAll("-", "/")}
                        </div>
                    </>
                )}
            </div>
            <div className="right">
                {isDelivered && (orderItemType.includes('CON')) &&
                    <button
                        className="primary-button"
                        data-element-id="OrderHistory_ViewDetails-ReorderContacts"
                        onClick={() => { handleContactLensesReorder(orderId, storeId, catalogId, langId, ocrAddressId) }}
                    >
                        {getLabelFallback(
                            'MYPURCHASES_ONLINE_ORDERS_REORDER_CONTACT_LENSES_CTA_LABEL'
                        )}
                    </button>
                }
                {orderItemCarrierUrl && !isMobile && (
                    <button
                        className="primary-button button-size-small custom-mob"
                        data-element-id="OrderDetails_TrackMyOrder"
                        onClick={() => goToTrackingPage(orderItemCarrierUrl)}
                    >
                        {getLabelFallback(
                            'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_TRACK_THIS_ITEM_CTA_LABEL'
                        )}
                    </button>
                )}
            </div>
            {orderItemCarrierUrl && isMobile && (
                <button
                    className="primary-button button-size-small custom-mob"
                    data-element-id="OrderDetails_TrackMyOrder"
                    onClick={() => goToTrackingPage(orderItemCarrierUrl)}
                >
                    {getLabelFallback(
                        'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_TRACK_THIS_ITEM_CTA_LABEL'
                    )}
                </button>
            )}
        </div>
    );
};

const renderAlertInfoPrescriptionNeeded = (
    dispatch: Dispatch<any>,
    config: any,
    orderId: string,
    orderAddressEmail: string,
    goToProvidePrescriptionSection: Function
): JSX.Element => {
    return (
        <div className="alert-info">
            <div className="left">
                <div className="info-icon">
                    <Error />
                </div>
                <div className="info-message">
                    <div className={'primary-message medium bold align-left dark-info'}>
                        {getLabelFallback(
                            'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_ALERT_INFO_MESSAGE_TITLE'
                        )}
                    </div>
                    <div className={'secondary-message small align-left dark-info'}>
                        {getLabelFallback(
                            'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_ALERT_INFO_MESSAGE_SUBTITLE'
                        )}
                        <a
                            data-element-id="OrderDetails_OEE"
                            data-description="Schedule"
                            href="#"
                            className="secondary-message small dark-info bold schedule"
                            onClick={() =>
                                window.open(
                                    config.callFromComponentToTO.myPurchases.orderDetail
                                        .scheduleEyeExam,
                                    '_parent'
                                )
                            }
                        >
                            {getLabelFallback(
                                'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_ALERT_INFO_MESSAGE_PLACEHOLDER'
                            )}
                        </a>
                    </div>
                </div>
            </div>
            <button
                className="primary-button button-size-small submit-now"
                data-element-id="OrderDetails_UploadPrescription"
                data-description="Submit"
                onClick={() => {
                    /*dispatch(
                        getEncryptedOnlineOrderId({
                            isMockRequest:
                                config.mockRequest,
                            storeId: config.storeId,
                            orderId: Number(obj.orderId),
                        })
                    )*/
                    goToProvidePrescriptionSection(orderId, orderAddressEmail);
                }}
            >
                {getLabelFallback(
                    'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_ALERT_INFO_SUBMIT_NOW_CTA_LABEL'
                )}
            </button>
        </div>
    );
};

const renderLenses = (lenses: any): JSX.Element[] => {
    return Object.values(lenses).map((p: any, index) => {
        if (p.name === 'Prescription') return; // do not display prescription info
        if (p.name === "Protection plan") return; //displayed already below
        if (!p.children) {
            return (
                <>
                    {/* <span key={'your-lenses-left'+index} className={'left-' + index}>{ p.name.replace(':', '') }</span> */}
                    <span
                        key={'your-lenses-right' + index}
                        className="secondary-message medium align-left dark-grey"
                    >
                        {p.description}
                    </span>
                </>
            );
        } else {
            return (
                <>
                    {/* <span key={'your-lenses-left'+index} className={'left-'+ index}>{ p.name.replace(':', '') }</span> */}
                    <ul key={'your-lenses-right' + index} className={'right-' + index}>
                        {p.children.map((child, index2) => {
                            return (
                                <li
                                    key={'label-' + index + '-child-' + index2}
                                    className="secondary-message medium align-left dark-grey"
                                >
                                    {child.name}
                                </li>
                            );
                        })}
                    </ul>
                </>
            );
        }
    });
};

const renderGlassesBody = (orderItem: IOnlineOrderItems, isMobile: boolean, frameSize: string): JSX.Element => {
    const [openLenses, setOpenLenses] = useState(false);

    return (
        <div className="glasses">
            <div className="glasses-header">
                <div className="glasses-header-row">
                    <div className="secondary-message align-left bold medium">
                        {getLabelFallback(
                            'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_FRAME_LABEL'
                        )}
                    </div>
                    <div className="secondary-message align-left medium margin-left">{orderItem.frame}</div>
                </div>
                <div className="glasses-header-row">
                    <div className="secondary-message align-left bold medium">
                        {getLabelFallback(
                            'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_FRAME_COLOR_LABEL'
                        )}
                    </div>
                    <div className="secondary-message align-left medium margin-left">{orderItem.color.charAt(0).toUpperCase() + orderItem.color.slice(1)}</div>
                </div>
                <div className="glasses-header-row">
                    <div className="secondary-message align-left bold medium">
                        {getLabelFallback(
                            'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_FRAME_SIZE_LABEL'
                        )}
                    </div>
                    <div className="secondary-message align-left medium margin-left">{frameSize}</div>
                </div>
            </div>
            {Object.keys(orderItem.lenses).length > 0 && (
                <div className="glasses-body">
                    <div
                        className={`secondary-message align-left bold ${(isMobile ? 'small' : 'medium') +
                            (openLenses ? ' arrow-top' : ' arrow-down')
                            } `}
                        onClick={() => setOpenLenses(!openLenses)}
                    >
                        {getLabelFallback(
                            'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_LENSES_LABEL'
                        )}
                        <ArrowDown16 />
                    </div>
                    {orderItem?.lenses && (
                        <div className={'lenses-container' + (openLenses ? ' show' : '')}>
                            {renderLenses(orderItem.lenses)}
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

const renderContactBody = (
    orderItem: IOnlineOrderItems,
    orderDetailsContactLenses: OrderDetailsContactLenses,
    isMobile: boolean
): JSX.Element => {
    const { oldPrice, newPrice } = orderItem;
    return (
        <div className="contact">
            <div className="contact-header secondary-message align-left medium">
                {orderItem.frame}
                <span className="contact-brand">{orderItem.brand}</span>
            </div>
            {orderDetailsContactLenses && (
                <>
                    <div className="contact-body">
                        {!isMobile ? renderDeskopTable(orderItem, orderDetailsContactLenses) : renderMobileTable(orderItem, orderDetailsContactLenses)}
                    </div>
                    <div className="price-box">
                        <div className="left">
                            {getLabelFallback(
                                'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_PRICE_BOX_LEFT_LABEL'
                            )}
                        </div>
                        <div className="right">
                            <span className="secondary-message align-right medium">
                                {getLabelFallback('CURRENCY_LABEL')}
                                {Math.round(
                                    (parseFloat(oldPrice.replace('$', '')) /
                                        sumQuantity(orderItem.quantity)) *
                                    100
                                ) / 100}
                            </span>
                            <span className="secondary-message align-left large bold">
                                {getLabelFallback('CURRENCY_LABEL')}
                                {Math.round(
                                    (parseFloat(newPrice.replace('$', '')) /
                                        sumQuantity(orderItem.quantity)) *
                                    100
                                ) / 100}
                            </span>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};
const renderMobileTable = (
    orderItem: IOnlineOrderItems,
    orderDetailsContactLenses: OrderDetailsContactLenses
): JSX.Element => {
    return (
        <div className="contact-table-order-detail">
            <table>
                <thead>
                    <tr>
                        <th className="secondary-message medium align-left bold">
                        </th>
                        {Object.values(orderDetailsContactLenses).every(element => element)
                            ? renderMobileTableHeader(
                                "LCON_AND_RCON",
                            )
                            : renderMobileTableHeader(
                                orderItem.orderItemType as string,
                            )}
                    </tr>
                </thead>

                {Object.values(orderDetailsContactLenses).every(element => element)
                    ? renderMobileTableBody(
                        "RCON_AND_LCON",
                        orderDetailsContactLenses,
                    )
                    : renderMobileTableBody(
                        orderItem.orderItemType as string,
                        orderDetailsContactLenses,
                    )}
            </table>
            <table>
                <tbody key={uuidv4()}>
                    <tr>
                        <td className="secondary-message medium align-left bold">
                            {getLabelFallback(
                                'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_BOXES_LABEL'
                            )}
                        </td>
                        {Object.values(orderDetailsContactLenses).every(element => element)
                            ? (orderItem.orderItemType as OnlineOrderItemType[]).map(
                                (orderItemType, index) =>
                                    renderBoxesQuantityMobile(orderItem.quantity[index])
                            )
                            : renderBoxesQuantityMobile(orderItem.quantity as string)
                        }
                    </tr>
                </tbody>
            </table>
        </div>
    );
};

const renderMobileTableBody = (
    orderItemType: string,
    orderDetailsContactLenses: OrderDetailsContactLenses,
): JSX.Element => {
    return (
        <>
            {orderItemType.includes("RCON_AND_LCON") ? (
                <tbody key={uuidv4()}>
                    <tr>
                        <td className="secondary-message medium align-left bold">
                            {getLabelFallback(
                                'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_POWER_LABEL'
                            )}
                        </td>
                        <td className="secondary-message medium align-left">
                            {orderDetailsContactLenses["rcon"].power}
                        </td>
                        <td className="secondary-message medium align-left">
                            {orderDetailsContactLenses["lcon"].power}
                        </td>
                    </tr>
                    <tr>
                        <td className="secondary-message medium align-left bold">
                            {getLabelFallback(
                                'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_BC_LABEL'
                            )}
                        </td>
                        <td className="secondary-message medium align-center">
                            {orderDetailsContactLenses["rcon"].bc}
                        </td>
                        <td className="secondary-message medium align-center">
                            {orderDetailsContactLenses["lcon"].bc}
                        </td>
                    </tr>
                    <tr>
                        <td className="secondary-message medium align-left bold">
                            {getLabelFallback(
                                'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_DIA_LABEL'
                            )}
                        </td>
                        <td className="secondary-message medium align-center">
                            {orderDetailsContactLenses["rcon"].dia}
                        </td>
                        <td className="secondary-message medium align-center">
                            {orderDetailsContactLenses["lcon"].dia}
                        </td>
                    </tr>
                    {(isCLAttributePresent(orderDetailsContactLenses, 'rcon', 'cyl') || isCLAttributePresent(orderDetailsContactLenses, 'lcon', 'cyl')) && (
                        <tr>
                            <th className="secondary-message medium align-left bold">
                                {getLabelFallback(
                                    'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_CYL_LABEL'
                                )}
                            </th>
                            <td className="secondary-message medium align-center">
                                {orderDetailsContactLenses["rcon"].cyl}
                            </td>
                            <td className="secondary-message medium align-center">
                                {orderDetailsContactLenses["lcon"].cyl}
                            </td>
                        </tr>
                    )}

                    {(isCLAttributePresent(orderDetailsContactLenses, 'rcon', 'axis') || isCLAttributePresent(orderDetailsContactLenses, 'lcon', 'axis')) && (
                        <tr>
                            <td className="secondary-message medium align-left bold">
                                {getLabelFallback(
                                    'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_AXIS_LABEL'
                                )}
                            </td>
                            <td className="secondary-message medium align-center">
                                {orderDetailsContactLenses["rcon"].axis}
                            </td>
                            <td className="secondary-message medium align-center">
                                {orderDetailsContactLenses["lcon"].axis}
                            </td>
                        </tr>
                    )}

                    {(isCLAttributePresent(orderDetailsContactLenses, 'rcon', 'color') || isCLAttributePresent(orderDetailsContactLenses, 'lcon', 'color')) && (
                        <tr>
                            <td className="secondary-message medium align-left bold">
                                {getLabelFallback(
                                    'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_COLOR_LABEL'
                                )}
                            </td>
                            <td className="secondary-message medium align-center">
                                {orderDetailsContactLenses["rcon"].color}
                            </td>
                            <td className="secondary-message medium align-center">
                                {orderDetailsContactLenses["lcon"].color}
                            </td>
                        </tr>
                    )}

                    {(isCLAttributePresent(orderDetailsContactLenses, 'rcon', 'add') || isCLAttributePresent(orderDetailsContactLenses, 'lcon', 'add')) && (
                        <tr>
                            <td className="secondary-message medium align-left bold">
                                {getLabelFallback(
                                    'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_ADD_LABEL'
                                )}
                            </td>
                            <td className="secondary-message medium align-center">
                                {orderDetailsContactLenses["rcon"].add}
                            </td>
                            <td className="secondary-message medium align-center">
                                {orderDetailsContactLenses["lcon"].add}
                            </td>
                        </tr>
                    )}

                </tbody>
            ) : (
                <tbody key={uuidv4()}>
                    <tr>
                        <td className="secondary-message medium align-left bold">
                            {getLabelFallback(
                                'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_POWER_LABEL'
                            )}
                        </td>
                        <td className="secondary-message medium align-left">
                            {orderDetailsContactLenses[orderItemType.toLowerCase()].power}
                        </td>
                    </tr>
                    <tr>
                        <th className="secondary-message medium align-left bold">
                            {getLabelFallback(
                                'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_BC_LABEL'
                            )}
                        </th>
                        <td className="secondary-message medium align-center">
                            {orderDetailsContactLenses[orderItemType.toLowerCase()].bc}
                        </td>
                    </tr>
                    <tr>
                        <td className="secondary-message medium align-left bold">
                            {getLabelFallback(
                                'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_DIA_LABEL'
                            )}
                        </td>
                        <td className="secondary-message medium align-center">
                            {orderDetailsContactLenses[orderItemType.toLowerCase()].dia}
                        </td>
                    </tr>
                    {(isCLAttributePresent(orderDetailsContactLenses, orderItemType.toLowerCase(), 'cyl')) && (
                        <tr>
                            <th className="secondary-message medium align-left bold">
                                {getLabelFallback(
                                    'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_CYL_LABEL'
                                )}
                            </th>
                            <td className="secondary-message medium align-center">
                                {orderDetailsContactLenses[orderItemType.toLowerCase()].cyl}
                            </td>
                        </tr>
                    )}
                    {(isCLAttributePresent(orderDetailsContactLenses, orderItemType.toLowerCase(), 'axis')) && (
                        <tr>
                            <td className="secondary-message medium align-left bold">
                                {getLabelFallback(
                                    'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_AXIS_LABEL'
                                )}
                            </td>
                            <td className="secondary-message medium align-center">
                                {orderDetailsContactLenses[orderItemType.toLowerCase()].axis}
                            </td>
                        </tr>
                    )}
                    {(isCLAttributePresent(orderDetailsContactLenses, orderItemType.toLowerCase(), 'color')) && (
                        <tr>
                            <td className="secondary-message medium align-left bold">
                                {getLabelFallback(
                                    'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_COLOR_LABEL'
                                )}
                            </td>
                            <td className="secondary-message medium align-center">
                                {orderDetailsContactLenses[orderItemType.toLowerCase()].color}
                            </td>
                        </tr>
                    )}
                    {(isCLAttributePresent(orderDetailsContactLenses, orderItemType.toLowerCase(), 'add')) && (
                        <tr>
                            <td className="secondary-message medium align-left bold">
                                {getLabelFallback(
                                    'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_ADD_LABEL'
                                )}
                            </td>
                            <td className="secondary-message medium align-center">
                                {orderDetailsContactLenses[orderItemType.toLowerCase()].add}
                            </td>
                        </tr>
                    )}
                </tbody>
            )}
        </>
    );
};

const renderMobileTableHeader = (
    orderItemType: string,
): JSX.Element => {
    return (
        <>
            {orderItemType === 'LCON_AND_RCON' && (
                <>
                    <th className="secondary-message medium align-left bold">
                        {getLabelFallback(
                            'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_EYE_TYPE_RIGHT_LABEL'
                        )
                        }
                    </th>
                    <th className="secondary-message medium align-left bold">
                        {getLabelFallback(
                            'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_EYE_TYPE_LEFT_LABEL'
                        )}
                    </th>
                </>
            )}
            {orderItemType === 'LCON' && (
                <th className="secondary-message medium align-left bold">
                    {getLabelFallback(
                        'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_EYE_TYPE_LEFT_LABEL'
                    )}
                </th>
            )}
            {orderItemType === 'RCON' && (
                <th className="secondary-message medium align-left bold">
                    {getLabelFallback(
                        'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_EYE_TYPE_RIGHT_LABEL'
                    )
                    }
                </th>
            )}
        </>
    );
}

const renderDesktopTableBody = (
    orderItemType: string,
    orderDetailsContactLenses: OrderDetailsContactLenses,
    quantity: string
): JSX.Element => {
    return (
        <tbody key={uuidv4()}>
            <tr>
                <td className="secondary-message medium align-left bold">
                    {orderItemType === 'LCON'
                        ? getLabelFallback(
                            'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_EYE_TYPE_LEFT_LABEL'
                        )
                        : getLabelFallback(
                            'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_EYE_TYPE_RIGHT_LABEL'
                        )}
                </td>
                <td className="secondary-message medium align-center">
                    {orderDetailsContactLenses[orderItemType.toLowerCase()].bc}
                </td>
                <td className="secondary-message medium align-center">
                    {orderDetailsContactLenses[orderItemType.toLowerCase()].dia}
                </td>
                <td className="secondary-message medium align-left">
                    {orderDetailsContactLenses[orderItemType.toLowerCase()].power}
                </td>
                {isCLAttributePresent(orderDetailsContactLenses, orderItemType.toLowerCase(), 'cyl') && (
                    <td className="secondary-message medium align-center">
                        {orderDetailsContactLenses[orderItemType.toLowerCase()].cyl}
                    </td>
                )}
                {isCLAttributePresent(orderDetailsContactLenses, orderItemType.toLowerCase(), 'axis') && (
                    <td className="secondary-message medium align-center">
                        {orderDetailsContactLenses[orderItemType.toLowerCase()].axis}
                    </td>
                )}
                {isCLAttributePresent(orderDetailsContactLenses, orderItemType.toLowerCase(), 'color') && (
                    <td className="secondary-message medium align-center">
                        {orderDetailsContactLenses[orderItemType.toLowerCase()].color}
                    </td>
                )}
                {isCLAttributePresent(orderDetailsContactLenses, orderItemType.toLowerCase(), 'add') && (
                    <td className="secondary-message medium align-center">
                        {orderDetailsContactLenses[orderItemType.toLowerCase()].add}
                    </td>
                )}
                {isCLAttributePresent(orderDetailsContactLenses, orderItemType.toLowerCase(), 'dominance') && (
                    <td className="secondary-message medium align-center">
                        {orderDetailsContactLenses[orderItemType.toLowerCase()].dominance}
                    </td>
                )}
            </tr>
        </tbody>
    );
};

const renderDeskopTable = (
    orderItem: IOnlineOrderItems,
    orderDetailsContactLenses: OrderDetailsContactLenses
): JSX.Element => {
    return (
        <div className="contact-table-order-detail">
            <table>
                <thead>
                    <tr>
                        <th className="secondary-message medium align-left bold">
                        </th>
                        <th className="secondary-message medium align-left bold">
                            {getLabelFallback(
                                'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_BC_LABEL'
                            )}
                        </th>
                        <th className="secondary-message medium align-left bold">
                            {getLabelFallback(
                                'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_DIA_LABEL'
                            )}
                        </th>
                        <th className="secondary-message medium align-left bold">
                            {getLabelFallback(
                                'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_POWER_LABEL'
                            )}
                        </th>
                        {(isCLAttributePresent(orderDetailsContactLenses, 'rcon', 'cyl') || isCLAttributePresent(orderDetailsContactLenses, 'lcon', 'cyl')) && (
                            <th className="secondary-message medium align-left bold">
                                {getLabelFallback(
                                    'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_CYL_LABEL'
                                )}
                            </th>
                        )}
                        {(isCLAttributePresent(orderDetailsContactLenses, 'rcon', 'axis') || isCLAttributePresent(orderDetailsContactLenses, 'lcon', 'axis')) && (
                            <th className="secondary-message medium align-left bold">
                                {getLabelFallback(
                                    'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_AXIS_LABEL'
                                )}
                            </th>
                        )}
                        {(isCLAttributePresent(orderDetailsContactLenses, 'rcon', 'color') || isCLAttributePresent(orderDetailsContactLenses, 'lcon', 'color')) && (
                            <th className="secondary-message medium align-left bold">
                                {getLabelFallback(
                                    'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_COLOR_LABEL'
                                )}
                            </th>
                        )}
                        {(isCLAttributePresent(orderDetailsContactLenses, 'rcon', 'add') || isCLAttributePresent(orderDetailsContactLenses, 'lcon', 'add')) && (
                            <th className="secondary-message medium align-left bold">
                                {getLabelFallback(
                                    'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_ADD_LABEL'
                                )}
                            </th>
                        )}
                        {(isCLAttributePresent(orderDetailsContactLenses, 'rcon', 'dominance') || isCLAttributePresent(orderDetailsContactLenses, 'lcon', 'dominance')) && (
                            <th className="secondary-message medium align-left bold">
                                {getLabelFallback(
                                    'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_DOMINANCE_LABEL'
                                )}
                            </th>
                        )}
                    </tr>
                </thead>

                {Object.values(orderDetailsContactLenses).every(element => element)
                    ? (orderItem.orderItemType as OnlineOrderItemType[]).map(
                        (orderItemType, index) =>
                            renderDesktopTableBody(
                                orderItemType,
                                orderDetailsContactLenses,
                                orderItem.quantity[index]
                            )
                    )
                    : renderDesktopTableBody(
                        orderItem.orderItemType as string,
                        orderDetailsContactLenses,
                        orderItem.quantity as string
                    )}
            </table>
            <table>
                <thead>
                    <tr>
                        <th className="secondary-message medium align-left bold">
                            {getLabelFallback(
                                'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_BOXES_LABEL'
                            )}
                        </th>
                    </tr>
                </thead>
                {Object.values(orderDetailsContactLenses).every(element => element)
                    ? (orderItem.orderItemType as OnlineOrderItemType[]).map(
                        (orderItemType, index) =>
                            renderBoxesQuantity(orderItem.quantity[index])
                    )
                    : renderBoxesQuantity(orderItem.quantity as string)
                }
            </table>
        </div>
    );
};

const renderBoxesQuantity = (quantity: string): JSX.Element => {
    return (
        <tbody key={uuidv4()}>
            <tr>
                <td className="secondary-message medium align-left margin-right-center quantity">
                    {parseInt(quantity)}
                </td>
            </tr>
        </tbody>
    )
}

const renderBoxesQuantityMobile = (quantity: string): JSX.Element => {
    return (
        <td className="secondary-message medium align-left margin-right-center quantity">
            {parseInt(quantity)}
        </td>
    )
}

const sumQuantity = quantity => {
    let sum = 0;
    if (typeof quantity === 'string') {
        return parseInt(quantity);
    }

    for (let i = 0; i < quantity.length; i++) {
        sum += parseInt(quantity[i]);
    }
    return sum;
};

const renderProductImage = imgUrl => {
    return (
        <BoxImage
            imageUrl={imgUrl}
            fallbackLabel={getLabelFallback('IMAGE_NON_AVAILABLE_LABEL')}
            imageAlt="Product image"
        />
    );
};

const renderBodyTile = (
    orderItem: IOnlineOrderItems,
    isMobile: boolean,
    orderDetailsContactLenses: OrderDetailsContactLenses,
    frameSize: string,
): JSX.Element => {
    const { imgUrl, productPageUrl, orderItemType, insuranceBenefits, oldPrice, newPrice } =
        orderItem;
    return (
        <div className="body">
            <div className="product-img">
                {!!productPageUrl ? (
                    <a href={productPageUrl}>{renderProductImage(imgUrl)}</a>
                ) : (
                    renderProductImage(imgUrl)
                )}
            </div>
            <div className="body-right">
                {['SUN', 'EYE'].includes(orderItemType as OnlineOrderItemType) &&
                    renderGlassesBody(orderItem, isMobile, frameSize)}
                {orderDetailsContactLenses &&
                    renderContactBody(orderItem, orderDetailsContactLenses, isMobile)}

                {insuranceBlock(orderItem)}

                <div className="common-footer">
                    {insuranceBenefits && (
                        <div className="row">
                            <span className="secondary-message align-left success bold medium">
                                {getLabelFallback(
                                    'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_INSURANCE_BENEFITS_LABEL'
                                )}
                            </span>
                            <span className="secondary-message align-left success large">
                                {insuranceBenefits}
                            </span>
                        </div>
                    )}
                    {/* CONDITIONS (
                        <div className="row">
                            <span
                                className={`secondary-message align-left success bold ${
                                    isMobile ? 'small' : 'medium'
                                }`}
                            >
                                {getLabelFallback(
                                    'INFORMATION'
                                )}
                            </span>
                            <span className="secondary-message align-left success large">
                                VALUE
                            </span>
                        </div>
                    )*/}
                    <div className="row">
                        <span className="secondary-message align-left bold medium total-row">
                            {['SUN', 'EYE'].includes(orderItemType as OnlineOrderItemType) ? (
                                getLabelFallback(
                                    'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_TOTAL_LABEL'
                                )
                            ) : (
                                <>
                                    <span className="secondary-message align-left bold medium">
                                        {getLabelFallback(
                                            'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_TOTAL_CL_LABEL'
                                        )}
                                    </span>
                                    <span className="secondary-message align-left medium">
                                        {getLabelFallback(
                                            'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_TOTAL_CL_SECOND_LABEL'
                                        ).replace('###NUM###', sumQuantity(orderItem.quantity))}
                                    </span>
                                </>
                            )}
                        </span>
                        <div className="total-container">
                            <span className="secondary-message align-right medium">{oldPrice}</span>
                            <span className="secondary-message align-left large bold">
                                {newPrice}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const insuranceBlock = (orderItem) => {
    for (const p of Object.values(orderItem.lenses)) {
        if (p.name === 'Protection plan') {
            let wrExpiration = orderItem.valid_until_EPP.split("T")[0].split("-");
            wrExpiration = `${wrExpiration[2]}/${wrExpiration[1]}/${wrExpiration[0]}`;
            let priceEpp = parseFloat(orderItem.priceEPP).toFixed(2);

            return (
                <>
                    <div className="protection_plan_section">
                        <div className="plan_description">
                            {p.description.charAt(0).toUpperCase() + p.description.slice(1).toLowerCase().replace("-", " ")}&nbsp;
                            <span className="expiration">{'(Valid until ' + wrExpiration + ')'}</span>
                        </div>
                        <span className="warranty_price">{'$' + priceEpp}</span>
                    </div>
                </>
            );
        }
    }
    return null;
};

const HorizontalTile = ({ orderItem, orderId, orderAddressEmail, billingAddressId, order }: Props) => {
    const dispatch = useDispatch();

    const isMobile = useSelector((state: RootState) => state.common.isMobile);
    const config = useSelector((state: RootState) => state.common.config);
    const encodedOrderId = useSelector((state: RootState) => state.myPurchases.encodedOrderId);
    const orderItemCarrierUrl = useSelector(
        (state: RootState) => state.myPurchases.orderItemCarrierUrl
    );
    const [modalPreview, setModalPreview] = useState(false);
    const prescriptionInfoDetails = useSelector(
        (state: RootState) => state.myPurchases.prescriptionInfoDetails
    );
    const [prescriptionFile, setPrescriptionFile] = useState(null);
    const [prescriptionDoctor, setPrescriptionDoctor] = useState(null);
    const [prescriptionManual, setPrescriptionManual] = useState(null);
    const [prescriptionFileName, setPrescriptionFileName] = useState(null);
    const [errorImg, setErrorImg] = useState(null);

    const [frameSize, setFrameSize] = useState('');

    const [orderDetailsContactLenses, setOrderDetailsContactLenses] =
        useState<OrderDetailsContactLenses>(null);

    const isCTEnabledTO = config.isCTEnabledTO;

    /** The function below redirects the user to the section for providing the RX prescription */
    const goToProvidePrescriptionSection = (orderId: string, orderAddressEmail: string) => {
        window.open(
            config.callFromComponentToTO.myPurchases.onlineOrders.sendItNow
                .replace('{catalogId}', config.catalogId)
                .replace('{langId}', config.langId)
                .replace('{storeId}', config.storeId)
                .replace('{orderId}', orderId)
                .replace('{email}', encodeURIComponent(orderAddressEmail)),
            '_parent'
        );
    };

    /*useEffect(() => {
        encodedOrderId && goToProvidePrescriptionSection(encodedOrderId);
        return () => {
            dispatch(actions.getEncryptedOnlineOrderIdSuccess(null));
        };
    }, [encodedOrderId]);*/

    useEffect(() => {
        if (!orderItem.orderItemType.includes("LCON") && !orderItem.orderItemType.includes("RCON")) {
            getFrameSize().then(size => {
                setFrameSize(size);
            });
        }
        dispatch(getPrescriptionInfo(config.mockRequest, config.storeId, orderId, config.userId));
    }, []);

    const getFilePrescription = async (
        storeId: string,
        contextUserId: string,
        fileName: string
    ) => {
        return new Promise((resolve, reject) => {
            const url = URLS.DOWNLOAD_PRESCRIPTION.replace('{storeId}', storeId.toString())
                .replace('{contextId}', contextUserId)
                .replace('{filename}', fileName);

            if (url) {
                axios({
                    url,
                    method: 'GET',
                    responseType: 'blob',
                })
                    .then(res => {
                        resolve(res);
                    })
                    .catch(err => {
                        reject(err.response);
                    });
            }
        });
    };

    const openPreview = () => {
        if (!!prescriptionInfoDetails) {
            const prescriptionDetails = prescriptionInfoDetails[orderItem.prescriptionId];
            if (!!prescriptionDetails) {
                if (prescriptionDetails.prescriptionType_p === 'callDoctor') {
                    setPrescriptionFile(null);
                    setPrescriptionManual(null);
                    setPrescriptionDoctor({
                        doctorAddress: {
                            address: prescriptionDetails.doctorAddress_p,
                            address2: '',
                            city: prescriptionDetails.doctorCity_p,
                            country: 'US',
                            stateProvince: prescriptionDetails.doctorState_p,
                            zipPostalCode: prescriptionDetails.doctorZip_p,
                        },
                        doctorName: prescriptionDetails.doctor,
                        doctorPhoneNumber: prescriptionDetails.telephone,
                        doctorFaxNumber: prescriptionDetails.doctorFax_p,
                        isValidDoctor: true,
                        clinic: prescriptionDetails.clinic,
                        doctorAddress_p: prescriptionDetails.doctorAddress_p,
                    });
                } else if (prescriptionDetails.prescriptionType_p === 'uploadPrescription') {
                    setPrescriptionDoctor(null);
                    setPrescriptionManual(null);
                    getFilePrescription(config.storeId, config.userId, prescriptionDetails.fileName)
                        .then((res: any) => {
                            var reader = new FileReader();
                            reader.onload = async function (e) {
                                setErrorImg(false);
                                setPrescriptionFile(e.target.result);
                            };
                            reader.readAsDataURL(res.data);
                            setPrescriptionFileName(prescriptionDetails.fileName);
                        })
                        .catch(err => {
                            console.error(
                                '>>> Get File prescription for CL => error status:',
                                err.status,
                                ', error: ',
                                err
                            );
                        });
                } else if (
                    prescriptionDetails.prescriptionType_p === 'rxcPrescription' ||
                    !prescriptionDetails.prescriptionType_p
                ) {
                    setPrescriptionDoctor(null);
                    setPrescriptionManual(null);
                    setPrescriptionFile(null);
                    if (
                        !!prescriptionDetails.fileName &&
                        prescriptionDetails.fileName !== undefined &&
                        prescriptionDetails.fileName !== ''
                    ) {
                        getFilePrescription(
                            config.storeId,
                            config.userId,
                            prescriptionDetails.fileName
                        )
                            .then((res: any) => {
                                var reader = new FileReader();
                                reader.onload = async function (e) {
                                    setErrorImg(false);
                                    setPrescriptionFile(e.target.result);
                                };
                                reader.readAsDataURL(res.data);
                                setPrescriptionFileName(prescriptionDetails.fileName);
                            })
                            .catch(err => {
                                console.error(
                                    '>>> Get File prescription for CL => error status:',
                                    err.status,
                                    ', error: ',
                                    err
                                );
                            });
                    } else if (
                        !!prescriptionDetails.doctor &&
                        prescriptionDetails.doctor !== undefined && prescriptionDetails.doctor !== MANUAL_PRESCRIPTION_DEFAULT_DOCTOR
                    ) {
                        setPrescriptionDoctor({
                            doctorAddress: {
                                address: prescriptionDetails.doctorAddress_p,
                                address2: '',
                                city: prescriptionDetails.doctorCity_p,
                                country: 'US',
                                stateProvince: prescriptionDetails.doctorState_p,
                                zipPostalCode: prescriptionDetails.doctorZip_p,
                            },
                            doctorName: prescriptionDetails.doctor,
                            doctorPhoneNumber: prescriptionDetails.telephone,
                            doctorFaxNumber: prescriptionDetails.doctorFax_p,
                            isValidDoctor: true,
                            clinic: prescriptionDetails.clinic,
                            doctorAddress_p: prescriptionDetails.doctorAddress_p,
                        });
                    } else {
                        setPrescriptionManual({
                            sph_od: prescriptionDetails.sphereRight,
                            sph_os: prescriptionDetails.sphereLeft,
                            cyl_od: prescriptionDetails.cylRight,
                            cyl_os: prescriptionDetails.cylLeft,
                            ax_od: prescriptionDetails.axisRight,
                            ax_os: prescriptionDetails.axisLeft,
                            pupillaryDistance: prescriptionDetails.pupillaryDistance,
                            pupillaryDistance_left: prescriptionDetails.pupillaryDistance_left,
                            add_od: prescriptionDetails.addRight,
                            add_os: prescriptionDetails.addLeft,
                            color_od: prescriptionDetails.colorRight,
                            color_os: prescriptionDetails.colorLeft,
                            prism_enabled: prescriptionDetails.prismEnabled,
                            vprism_os: prescriptionDetails.prismEnabled
                                ? prescriptionDetails.osVPrism
                                : null,
                            vprism_base_os: prescriptionDetails.prismEnabled
                                ? prescriptionDetails.osVPrismBaseDir
                                : null,
                            vprism_od: prescriptionDetails.prismEnabled
                                ? prescriptionDetails.odVPrism
                                : null,
                            vprism_base_od: prescriptionDetails.prismEnabled
                                ? prescriptionDetails.odVPrismBaseDir
                                : null,
                            hprism_os: prescriptionDetails.prismEnabled
                                ? prescriptionDetails.osHPrism
                                : null,
                            hprism_base_os: prescriptionDetails.prismEnabled
                                ? prescriptionDetails.osHPrismBaseDir
                                : null,
                            hprism_od: prescriptionDetails.prismEnabled
                                ? prescriptionDetails.odHPrism
                                : null,
                            hprism_base_od: prescriptionDetails.prismEnabled
                                ? prescriptionDetails.odHPrismBaseDir
                                : null,
                        });
                    }
                }
            }
            setModalPreview(true);
        }
    };

    useEffect(() => {
        if (['LCON', 'RCON'].includes(orderItem.orderItemType as OnlineOrderItemType)) {
            const payload: OnlineOrderDetailsSkuDetails = {
                isMockRequest: config.mockRequest,
                storeId: config.storeId,
                currency: config.currencyCode,
                catalogId: config.catalogId,
                orderItemType: orderItem.orderItemType as Omit<OnlineOrderItemType, 'EYE' | 'SUN'>,
                productId: orderItem.productId as string,
            };

            getContactLensesAttributes(payload).then(result => {
                const mappedResult = mapContactLensesAttributes({
                    ...result?.data,
                    orderItemType: orderItem.orderItemType,
                });

                setOrderDetailsContactLenses(mappedResult);
            });
        }
        if (
            orderItem.orderItemType.length === 2 &&
            multipleExist(['LCON', 'RCON'], orderItem.orderItemType as OnlineOrderItemType[])
        ) {
            const firstPayload: OnlineOrderDetailsSkuDetails = {
                isMockRequest: config.mockRequest,
                storeId: config.storeId,
                currency: config.currencyCode,
                catalogId: config.catalogId,
                orderItemType: orderItem.orderItemType[0] as Omit<
                    OnlineOrderItemType,
                    'EYE' | 'SUN'
                >,
                productId: orderItem.productId[0] as string,
            };

            const secondPayload: OnlineOrderDetailsSkuDetails = {
                isMockRequest: config.mockRequest,
                storeId: config.storeId,
                currency: config.currencyCode,
                catalogId: config.catalogId,
                orderItemType: orderItem.orderItemType[1] as Omit<
                    OnlineOrderItemType,
                    'EYE' | 'SUN'
                >,
                productId: orderItem.productId[1] as string,
            };
            getFullContactLensesAttributes(firstPayload, secondPayload);
        }
        (orderItem.orderStatus === 'S' ||
            orderItem.orderStatus === 'D' ||
            orderItem.orderStatus === 'U') &&
            dispatch(
                getOrderItemCarrierUrl({
                    isMockRequest: config.mockRequest,
                    storeId: config.storeId,
                    orderItemId: orderItem.orderItemId,
                })
            );
        return () => {
            setOrderDetailsContactLenses(null);
            dispatch(actions.getOrderItemCarrierUrlSuccess(null));
        };
    }, [orderItem]);

    async function getContactLensesAttributes(payload: OnlineOrderDetailsSkuDetails): Promise<any> {
        const { isMockRequest, orderItemType, ...rest } = payload;

        if (isMockRequest) {
            const onlineOrderDetailsSkuDetails =
                '/data/mocks/my_purchases_get_online_order_details_sku_details_mock.json';
            return getMockedFile(onlineOrderDetailsSkuDetails);
        } else {
            const onlineOrderDetailsSkuDetailsUrl =
                URLS.GET_PRESCRIPTION_VALUES.replace(
                    '{storeId}',
                    rest.storeId.toString()
                )
                    .replace('{productId}', rest.productId)
                    .replace('{noCache}', new Date().getTime().toString());

            const config: AxiosRequestConfig = {
                method: 'GET',
                url: onlineOrderDetailsSkuDetailsUrl,
                headers: { 'Content-Type': 'application/json' },
            };

            return axios(config);
        }
    }

    async function getFullContactLensesAttributes(
        firstPayload: OnlineOrderDetailsSkuDetails,
        secondPayload: OnlineOrderDetailsSkuDetails
    ) {
        try {
            const res = await Promise.all([
                getContactLensesAttributes(firstPayload),
                getContactLensesAttributes(secondPayload),
            ]);

            const mappedResult1 = mapContactLensesAttributes({
                ...res[0]?.data,
                orderItemType: firstPayload.orderItemType,
            });
            const mappedResult2 = mapContactLensesAttributes({
                ...res[1]?.data,
                orderItemType: secondPayload.orderItemType,
            });
            setOrderDetailsContactLenses({ rcon: mappedResult1.rcon ?? mappedResult2.rcon, lcon: mappedResult2.lcon ?? mappedResult1.lcon });
        } catch {
            setOrderDetailsContactLenses(null);
        }
    }

    const renderCompletePrescription = (): JSX.Element => {
        return (
            <div className="prescription">
                <div className="left">
                    <div className="info-icon">
                        <CheckPrescription />
                    </div>
                    <div className="info-message">
                        <div className={'primary-message bold align-left dark-info prescription-submitted'}>
                            {getLabelFallback(
                                'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_PRESCRIPTION_MESSAGE_TITLE'
                            )}
                        </div>
                        <div className={'secondary-message align-left dark-info'}>
                            {getLabelFallback(
                                'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_PRESCRIPTION_MESSAGE_SUBTITLE'
                            )}
                        </div>
                    </div>
                </div>
                <a
                    className="secondary-message dark-info bold preview"
                    onClick={() => {
                        openPreview();
                    }}
                >
                    {getLabelFallback(
                        'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_PRESCRIPTION_PREVIEW'
                    )}
                </a>
            </div>
        );
    };

    const renderModalPreview = (): JSX.Element => {
        return (
            <Modal isOpen={modalPreview} close={() => setModalPreview(false)}>
                <PrescriptionModal
                    prescriptionFile={prescriptionFile}
                    prescriptionDoctor={prescriptionDoctor}
                    prescriptionManual={prescriptionManual}
                    errorImgInner={errorImg}
                    prescriptionFileName={prescriptionFileName}
                />
            </Modal>
        );
    };

    /** The function below redirects the user to the order item tracking page */
    const goToTrackingPage = (orderItemCarrierUrl: string) =>
        window.open(orderItemCarrierUrl, '_blank');

    /** The function below checks if all values exists in the array */
    const multipleExist = (arr: string[], values: string[]): boolean => {
        return values.every(value => {
            return arr.includes(value);
        });
    };

    async function getFrameSize() {
        try {
            const result = await getProductDetails(orderItem.productId);
            const bridgeWidthObj = result.data.CatalogEntryView[0].Attributes.find((el) => el.name === 'BRIDGE_WIDTH');
            const lensWidthObj = result.data.CatalogEntryView[0].Attributes.find((el) => el.name === 'LENS_WIDTH');
            const bridgeWidth = bridgeWidthObj.Values[0].values;
            const lensWidth = lensWidthObj.Values[0].values;
            const res = lensWidth + "-" + bridgeWidth;
            return res;
        } catch (error) {
            console.error('Error while fetching size:', error);
            return '';
        }
    }
    //when orderItem is CL the orderItemType is an array
    var oIType = ''
    if (Array.isArray(orderItem.orderItemType)) {
        oIType = orderItem.orderItemType[0];
    } else {
        oIType = orderItem.orderItemType;
    }

    return (
        <div className="horizontal-tile">
            {!orderItem.isPrescriptionRequired &&
                renderShippedHeaderTile(
                    orderItemCarrierUrl,
                    goToTrackingPage,
                    orderItem.orderStatus === 'D',
                    Number(orderId),
                    billingAddressId,
                    Number(config.storeId),
                    Number(config.catalogId),
                    Number(config.langId),
                    order,
                    orderItem.orderStatus,
                    orderItem.edd,
                    oIType,
                    isCTEnabledTO
                )}
            {/* CAPIRE SE HA UNA PRESCRIZIONE */}
            {orderItem.isPrescriptionRequired ? (
                renderAlertInfoPrescriptionNeeded(
                    dispatch,
                    config,
                    orderId,
                    orderAddressEmail,
                    goToProvidePrescriptionSection
                )
            ) : !!orderItem.prescriptionId ? (
                renderCompletePrescription()
            ) : (
                <></>
            )}
            {(!!prescriptionFile || !!prescriptionDoctor || !!prescriptionManual) &&
                renderModalPreview()}
            {renderBodyTile(orderItem, isMobile, orderDetailsContactLenses, frameSize)}
        </div>
    );
};
export default HorizontalTile;
